/* PTMROM-264 / PB-5037 — CES + NPS bottom-sheet; PB-5039 — Share Feedback modal (Apps 480 / 481) */
window.feedbackSurvey = (function () {
  "use strict";

  var SURVEY_CES = "CES_7";
  var SURVEY_NPS = "NPS_10";

  /** Session item: set to Y after first popup this session (max one survey per session). */
  var SESSION_ITEM = "FEEDBACK_SHOWN_THIS_SESSION";

  /** Set by trigger pages (e.g. modal 301 submit); consumed by runPending() on landing page. */
  var PENDING_APPLICATION_ITEM = "FEEDBACK_PENDING_APPLICATION";
  var PENDING_TRIGGER_ITEM = "FEEDBACK_PENDING_TRIGGER";

  /** Fallback when applicationCode / triggerCode not passed — App 480 / 481 CES confirm-sending. */
  var APP_ID_DEFAULTS = {
    480: { applicationCode: "REQUESTER", triggerCode: "CONFIRM_SENDING_REQUEST" },
    481: { applicationCode: "PROVIDER", triggerCode: "CONFIRM_SENDING_OFFER" }
  };

  /** LOGIN NPS chain after pending CES check (runPending). */
  var LOGIN_DEFAULTS = {
    480: { applicationCode: "REQUESTER", triggerCode: "LOGIN" },
    481: { applicationCode: "PROVIDER", triggerCode: "LOGIN" }
  };

  /** APEX Ajax Callback process names. */
  var PROCESS_CHECK = "AP_FEEDBACK_CHECK";
  var PROCESS_RUN_PENDING = "AP_FEEDBACK_RUN_PENDING";
  var PROCESS_SUBMIT = "AP_FEEDBACK_SUBMIT";
  var PROCESS_DISMISS = "AP_FEEDBACK_DISMISS";
  var PROCESS_SUBMIT_SHARE = "AP_FEEDBACK_SUBMIT_SHARE";

  /** APEX Text Messages — CES (Apps 480 / 481). */
  var MSG = {
    HEADING: "FEEDBACK_CES_HEADING",
    NO_THANKS: "FEEDBACK_CES_NO_THANKS",
    COMMENT_LABEL: "FEEDBACK_CES_COMMENT_LABEL",
    SUBMIT: "FEEDBACK_CES_SUBMIT",
    TOAST_POSITIVE: "FEEDBACK_CES_TOAST_POSITIVE",
    TOAST_NEGATIVE: "FEEDBACK_CES_TOAST_NEGATIVE",
    CLOSE: "APEX.DIALOG.CLOSE",
    SCALE: [
      "FEEDBACK_CES_SCALE_1",
      "FEEDBACK_CES_SCALE_2",
      "FEEDBACK_CES_SCALE_3",
      "FEEDBACK_CES_SCALE_4",
      "FEEDBACK_CES_SCALE_5",
      "FEEDBACK_CES_SCALE_6",
      "FEEDBACK_CES_SCALE_7"
    ]
  };

  /** APEX Text Messages — NPS (PB-5037; create in App Builder Step 3). */
  var MSG_NPS = {
    NO_THANKS: "FEEDBACK_NPS_NO_THANKS",
    SUBMIT: "FEEDBACK_NPS_SUBMIT",
    FOLLOWUP_HEADING: "FEEDBACK_NPS_FOLLOWUP_HEADING",
    FOLLOWUP_PLACEHOLDER: "FEEDBACK_NPS_FOLLOWUP_PLACEHOLDER",
    SCALE_LEFT: "FEEDBACK_NPS_SCALE_LEFT",
    SCALE_RIGHT: "FEEDBACK_NPS_SCALE_RIGHT",
    TOAST_POSITIVE: "FEEDBACK_NPS_TOAST_POSITIVE",
    TOAST_NEGATIVE: "FEEDBACK_NPS_TOAST_NEGATIVE",
    CLOSE: "APEX.DIALOG.CLOSE"
  };

  /** APEX Text Messages — Share Feedback (PB-5039; Help menu). */
  var MSG_SHARE = {
    HEADING: "FEEDBACK_SHARE_HEADING",
    SUBTEXT: "FEEDBACK_SHARE_SUBTEXT",
    PLACEHOLDER: "FEEDBACK_SHARE_PLACEHOLDER",
    SUBMIT: "FEEDBACK_SHARE_SUBMIT",
    TOAST: "FEEDBACK_SHARE_TOAST",
    VALIDATION_EMPTY: "FEEDBACK_SHARE_VALIDATION_EMPTY",
    CLOSE: "APEX.DIALOG.CLOSE"
  };

  /** In-memory state for the active survey instance. */
  var state = {
    responseseq: null,
    surveyType: SURVEY_CES,
    selectedScore: null,
    isSubmitting: false,
    checkInFlight: false
  };

  /** Cached DOM nodes (overlay + toast), created once on first open. */
  var dom = {
    overlay: null,
    toast: null
  };

  /** Share Feedback centered modal (PB-5039). */
  var shareDom = {
    overlay: null
  };

  var shareState = {
    isSubmitting: false
  };

  var keydownBound = false;

  /** PB-5921 — eligible response held back while an APEX modal dialog (e.g. Release Notes) is open. */
  var deferredCheckResponse = null;
  var modalWatcherBound = false;

  /**
   * @param {*} value
   * @returns {boolean}
   */
  function isNonEmpty(value) {
    return value != null && String(value).trim() !== "";
  }

  /**
   * @returns {boolean}
   */
  function isNpsSurvey() {
    return state.surveyType === SURVEY_NPS;
  }

  /**
   * App-id fallback for legacy / partial config (480 Requester, 481 Provider).
   * @returns {{ applicationCode: string, triggerCode: string }|null}
   */
  function resolveAppIdDefaults() {
    var appId = Number($v("pFlowId"));
    return APP_ID_DEFAULTS[appId] || null;
  }

  /**
   * LOGIN trigger defaults for NPS on page 0 (480 / 481).
   * @returns {{ applicationCode: string, triggerCode: string }|null}
   */
  function resolveLoginDefaults() {
    var appId = Number($v("pFlowId"));
    return LOGIN_DEFAULTS[appId] || null;
  }

  /**
   * Application code for Share Feedback submit (480 Requester, 481 Provider).
   * @returns {string|null}
   */
  function resolveShareApplicationCode() {
    var appId = Number($v("pFlowId"));
    if (appId === 480) {
      return "REQUESTER";
    }
    if (appId === 481) {
      return "PROVIDER";
    }
    return null;
  }

  /**
   * Share Feedback labels from APEX Text Messages.
   */
  function getShareLabels() {
    return {
      heading: apex.lang.getMessage(MSG_SHARE.HEADING),
      subtext: apex.lang.getMessage(MSG_SHARE.SUBTEXT),
      placeholder: apex.lang.getMessage(MSG_SHARE.PLACEHOLDER),
      submit: apex.lang.getMessage(MSG_SHARE.SUBMIT),
      toast: apex.lang.getMessage(MSG_SHARE.TOAST),
      validationEmpty: apex.lang.getMessage(MSG_SHARE.VALIDATION_EMPTY),
      close: apex.lang.getMessage(MSG_SHARE.CLOSE)
    };
  }

  /**
   * Escape closes share modal or CES/NPS sheet (one listener).
   */
  function bindEscapeClose() {
    if (keydownBound) {
      return;
    }
    keydownBound = true;
    document.addEventListener("keydown", function (evt) {
      if (evt.key !== "Escape") {
        return;
      }
      if (shareDom.overlay && !shareDom.overlay.hidden) {
        onShareClose();
        return;
      }
      if (dom.overlay && !dom.overlay.hidden) {
        onDismiss();
      }
    });
  }

  /**
   * Resolves applicationCode + triggerCode from explicit config or app-id fallback.
   * @param {{ applicationCode?: string, triggerCode?: string }|undefined} config
   * @returns {{ applicationCode: string, triggerCode: string }|null}
   */
  function resolveTriggerConfig(config) {
    config = config || {};
    var applicationCode = isNonEmpty(config.applicationCode)
      ? String(config.applicationCode).trim()
      : null;
    var triggerCode = isNonEmpty(config.triggerCode)
      ? String(config.triggerCode).trim()
      : null;

    if (applicationCode && triggerCode) {
      return { applicationCode: applicationCode, triggerCode: triggerCode };
    }

    if (triggerCode && !applicationCode) {
      var partialFallback = resolveAppIdDefaults();
      if (partialFallback) {
        return { applicationCode: partialFallback.applicationCode, triggerCode: triggerCode };
      }
    }

    if (!applicationCode && !triggerCode) {
      return resolveAppIdDefaults();
    }

    return null;
  }

  /**
   * True while any APEX modal dialog (e.g. Release Notes) is open.
   * The feedback sheet is appended to document.body outside the dialog's DOM,
   * so it must not be shown at the same time — see bindModalWatcher().
   * @returns {boolean}
   */
  function isApexModalOpen() {
    if (window.apex && apex.jQuery) {
      return apex.jQuery(".ui-dialog:visible").length > 0;
    }
    return false;
  }

  /**
   * Retries a held-back eligible response once a dialog closes.
   * Listens for jQuery UI's own widget lifecycle event (dialogclose) rather than
   * relying solely on APEX's apexafterclosedialog/apexafterclosecanceldialog —
   * confirmed via live testing that not every dialog close path fires the latter,
   * but dialogclose always does (it's the underlying widget's own close hook).
   * Bound once; re-defers itself if another modal is still open right after closing.
   */
  function bindModalWatcher() {
    if (modalWatcherBound || !(window.apex && apex.jQuery)) {
      return;
    }
    modalWatcherBound = true;
    apex.jQuery(document).on("dialogclose apexafterclosedialog apexafterclosecanceldialog", function () {
      if (!deferredCheckResponse) {
        return;
      }
      var pending = deferredCheckResponse;
      deferredCheckResponse = null;
      handleCheckResponse(pending);
    });
  }

  /**
   * Opens the sheet when AP_FEEDBACK_CHECK / AP_FEEDBACK_RUN_PENDING returns eligible.
   * Held back (not shown) while an APEX modal dialog is open — see isApexModalOpen().
   * @param {*} pData Ajax JSON response
   */
  function handleCheckResponse(pData) {
    if (!pData || pData.success !== true || pData.eligible !== true) {
      return;
    }
    if (isApexModalOpen()) {
      bindModalWatcher();
      deferredCheckResponse = pData;
      return;
    }
    state.surveyType = pData.surveytype === SURVEY_NPS ? SURVEY_NPS : SURVEY_CES;
    state.responseseq = pData.responseseq;
    openSheet(pData.questiontext);
  }

  /**
   * CES labels from APEX Text Messages.
   */
  function getCesLabels() {
    return {
      heading: apex.lang.getMessage(MSG.HEADING),
      scale: MSG.SCALE.map(function (messageName) {
        return apex.lang.getMessage(messageName);
      }),
      noThanks: apex.lang.getMessage(MSG.NO_THANKS),
      commentLabel: apex.lang.getMessage(MSG.COMMENT_LABEL),
      submit: apex.lang.getMessage(MSG.SUBMIT),
      toastPositive: apex.lang.getMessage(MSG.TOAST_POSITIVE),
      toastNegative: apex.lang.getMessage(MSG.TOAST_NEGATIVE),
      close: apex.lang.getMessage(MSG.CLOSE)
    };
  }

  /**
   * NPS labels from APEX Text Messages.
   */
  function getNpsLabels() {
    return {
      noThanks: apex.lang.getMessage(MSG_NPS.NO_THANKS),
      followupHeading: apex.lang.getMessage(MSG_NPS.FOLLOWUP_HEADING),
      followupPlaceholder: apex.lang.getMessage(MSG_NPS.FOLLOWUP_PLACEHOLDER),
      scaleLeft: apex.lang.getMessage(MSG_NPS.SCALE_LEFT),
      scaleRight: apex.lang.getMessage(MSG_NPS.SCALE_RIGHT),
      submit: apex.lang.getMessage(MSG_NPS.SUBMIT),
      toastPositive: apex.lang.getMessage(MSG_NPS.TOAST_POSITIVE),
      toastNegative: apex.lang.getMessage(MSG_NPS.TOAST_NEGATIVE),
      close: apex.lang.getMessage(MSG_NPS.CLOSE)
    };
  }

  /**
   * Creates overlay, bottom sheet, and toast DOM once and wires click handlers.
   * Safe to call multiple times — no-op after first run.
   */
  function ensureDom() {
    if (dom.overlay) {
      return;
    }

    dom.overlay = document.createElement("div");
    dom.overlay.className = "rf-feedback-overlay";
    dom.overlay.hidden = true;
    dom.overlay.setAttribute("role", "presentation");
    dom.overlay.innerHTML =
      '<section class="rf-feedback-sheet rf-feedback-sheet--ces" role="dialog" aria-modal="true" aria-labelledby="rfFeedbackTitle">' +
      '  <div class="rf-feedback-sheet__header">' +
      '    <h2 class="rf-feedback-sheet__title" id="rfFeedbackTitle"></h2>' +
      '    <button type="button" class="rf-feedback-sheet__close" aria-label="">&times;</button>' +
      "  </div>" +
      '  <p class="rf-feedback-sheet__question"></p>' +
      '  <div class="rf-feedback-scale"></div>' +
      '  <div class="rf-feedback-nps-scale-labels">' +
      '    <span class="rf-feedback-nps-scale-labels__left"></span>' +
      '    <span class="rf-feedback-nps-scale-labels__right"></span>' +
      "  </div>" +
      '  <div class="rf-feedback-step2">' +
      '    <label class="rf-feedback-step2__label" for="rfFeedbackComment"></label>' +
      '    <textarea id="rfFeedbackComment" class="rf-feedback-step2__comment" maxlength="2000" rows="3"></textarea>' +
      '    <button type="button" class="rf-feedback-step2__submit"></button>' +
      "  </div>" +
      '  <div class="rf-feedback-sheet__footer">' +
      '    <button type="button" class="rf-feedback-sheet__dismiss"></button>' +
      "  </div>" +
      "</section>";

    dom.toast = document.createElement("div");
    dom.toast.className = "rf-feedback-toast";
    dom.toast.setAttribute("role", "status");
    dom.toast.setAttribute("aria-live", "polite");

    document.body.appendChild(dom.overlay);
    document.body.appendChild(dom.toast);

    dom.overlay.querySelector(".rf-feedback-sheet__close").addEventListener("click", onDismiss);
    dom.overlay.querySelector(".rf-feedback-sheet__dismiss").addEventListener("click", onDismiss);
    dom.overlay.querySelector(".rf-feedback-step2__submit").addEventListener("click", onSubmit);
    dom.overlay.addEventListener("click", function (evt) {
      if (evt.target === dom.overlay) {
        onDismiss();
      }
    });

    bindEscapeClose();
  }

  /**
   * Creates centered Share Feedback modal once and wires handlers.
   */
  function ensureShareDom() {
    if (shareDom.overlay) {
      return;
    }

    shareDom.overlay = document.createElement("div");
    shareDom.overlay.className = "rf-feedback-share-overlay";
    shareDom.overlay.hidden = true;
    shareDom.overlay.setAttribute("role", "presentation");
    shareDom.overlay.innerHTML =
      '<section class="rf-feedback-share-modal" role="dialog" aria-modal="true" aria-labelledby="rfFeedbackShareTitle">' +
      '  <div class="rf-feedback-share-modal__header">' +
      '    <h2 class="rf-feedback-share-modal__title" id="rfFeedbackShareTitle"></h2>' +
      '    <button type="button" class="rf-feedback-share-modal__close" aria-label="">&times;</button>' +
      "  </div>" +
      '  <p class="rf-feedback-share-modal__subtext"></p>' +
      '  <textarea id="rfFeedbackShareComment" class="rf-feedback-share-modal__comment" maxlength="2000" rows="5"></textarea>' +
      '  <p class="rf-feedback-share-modal__error" role="alert" hidden></p>' +
      '  <button type="button" class="rf-feedback-share-modal__submit"></button>' +
      "</section>";

    document.body.appendChild(shareDom.overlay);

    shareDom.overlay.querySelector(".rf-feedback-share-modal__close").addEventListener("click", onShareClose);
    shareDom.overlay.querySelector(".rf-feedback-share-modal__submit").addEventListener("click", onShareSubmit);
    shareDom.overlay.addEventListener("click", function (evt) {
      if (evt.target === shareDom.overlay) {
        onShareClose();
      }
    });
    shareDom.overlay.querySelector("#rfFeedbackShareComment").addEventListener("input", function () {
      var errorNode = shareDom.overlay.querySelector(".rf-feedback-share-modal__error");
      errorNode.hidden = true;
      errorNode.textContent = "";
    });

    bindEscapeClose();
  }

  /**
   * Opens Share Feedback from Help menu — no server call until submit.
   */
  function openShare() {
    if (!resolveShareApplicationCode()) {
      return;
    }

    ensureShareDom();
    ensureDom();

    var labels = getShareLabels();
    var errorNode = shareDom.overlay.querySelector(".rf-feedback-share-modal__error");
    var commentNode = shareDom.overlay.querySelector("#rfFeedbackShareComment");

    shareDom.overlay.querySelector(".rf-feedback-share-modal__title").textContent = labels.heading;
    shareDom.overlay.querySelector(".rf-feedback-share-modal__subtext").textContent = labels.subtext;
    commentNode.value = "";
    commentNode.setAttribute("placeholder", labels.placeholder);
    shareDom.overlay.querySelector(".rf-feedback-share-modal__submit").textContent = labels.submit;
    shareDom.overlay.querySelector(".rf-feedback-share-modal__submit").disabled = false;
    shareDom.overlay.querySelector(".rf-feedback-share-modal__close").setAttribute("aria-label", labels.close);
    errorNode.textContent = "";
    errorNode.hidden = true;

    shareState.isSubmitting = false;
    shareDom.overlay.hidden = false;
    document.body.classList.add("rf-feedback-open");
    commentNode.focus();
  }

  /**
   * Close Share modal (X, backdrop, Escape) — no storage, no toast.
   */
  function closeShare() {
    if (!shareDom.overlay) {
      return;
    }
    shareDom.overlay.hidden = true;
    shareState.isSubmitting = false;
    if (!dom.overlay || dom.overlay.hidden) {
      document.body.classList.remove("rf-feedback-open");
    }
  }

  function onShareClose() {
    if (shareState.isSubmitting) {
      return;
    }
    closeShare();
  }

  /**
   * Submit Share Feedback via AP_FEEDBACK_SUBMIT_SHARE (pkg_feedback.p_submitShareFeedback).
   */
  function onShareSubmit() {
    if (shareState.isSubmitting) {
      return;
    }

    var applicationCode = resolveShareApplicationCode();
    if (!applicationCode) {
      return;
    }

    var labels = getShareLabels();
    var commentNode = shareDom.overlay.querySelector("#rfFeedbackShareComment");
    var errorNode = shareDom.overlay.querySelector(".rf-feedback-share-modal__error");
    var commentText = String(commentNode.value || "").trim();

    if (!isNonEmpty(commentText)) {
      errorNode.textContent = labels.validationEmpty;
      errorNode.hidden = false;
      commentNode.focus();
      return;
    }

    errorNode.textContent = "";
    errorNode.hidden = true;
    shareState.isSubmitting = true;
    shareDom.overlay.querySelector(".rf-feedback-share-modal__submit").disabled = true;

    apex.server.process(
      PROCESS_SUBMIT_SHARE,
      { p_clob_01: commentText },
      {
        dataType: "json",
        success: function (pData) {
          shareState.isSubmitting = false;
          if (pData && pData.success === false) {
            shareDom.overlay.querySelector(".rf-feedback-share-modal__submit").disabled = false;
            handleAjaxError({ responseText: pData.message || "" });
            return;
          }
          closeShare();
          showToast(labels.toast);
        },
        error: function (err) {
          shareState.isSubmitting = false;
          shareDom.overlay.querySelector(".rf-feedback-share-modal__submit").disabled = false;
          handleAjaxError(err);
        }
      }
    );
  }

  /**
   * Builds the seven CES score buttons (1–7) with translated labels and click handlers.
   * @param {string[]} labels Translated scale labels from getCesLabels().scale
   */
  function renderCesScale(labels) {
    var scaleNode = dom.overlay.querySelector(".rf-feedback-scale");
    scaleNode.innerHTML = "";
    labels.forEach(function (label, idx) {
      var score = idx + 1;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "rf-feedback-scale__btn rf-feedback-scale__btn--" + score;
      btn.textContent = label;
      btn.setAttribute("data-score", String(score));
      btn.addEventListener("click", function () {
        onScoreSelected(score, btn);
      });
      scaleNode.appendChild(btn);
    });
  }

  /**
   * Builds eleven NPS score circles (0–10).
   */
  function renderNpsScale() {
    var scaleNode = dom.overlay.querySelector(".rf-feedback-scale");
    scaleNode.innerHTML = "";
    for (var score = 0; score <= 10; score += 1) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "rf-feedback-nps-scale__btn";
      btn.textContent = String(score);
      btn.setAttribute("data-score", String(score));
      btn.addEventListener("click", function (evt) {
        var node = evt.currentTarget;
        onScoreSelected(Number(node.getAttribute("data-score")), node);
      });
      scaleNode.appendChild(btn);
    }
  }

  /**
   * Applies CES vs NPS layout classes and static labels.
   * @param {string} questionText Campaign question from server
   */
  function resetUi(questionText) {
    var sheet = dom.overlay.querySelector(".rf-feedback-sheet");
    var scaleNode = dom.overlay.querySelector(".rf-feedback-scale");
    var npsLabelsNode = dom.overlay.querySelector(".rf-feedback-nps-scale-labels");
    var questionNode = dom.overlay.querySelector(".rf-feedback-sheet__question");
    var commentNode = dom.overlay.querySelector("#rfFeedbackComment");

    sheet.classList.toggle("rf-feedback-sheet--nps", isNpsSurvey());
    sheet.classList.toggle("rf-feedback-sheet--ces", !isNpsSurvey());
    scaleNode.classList.toggle("rf-feedback-scale--nps", isNpsSurvey());
    questionNode.classList.remove("is-faded");

    dom.overlay.querySelector(".rf-feedback-step2").classList.remove("is-visible");
    dom.overlay.querySelector(".rf-feedback-sheet__footer").classList.remove("is-hidden");
    dom.overlay.querySelector(".rf-feedback-step2__submit").disabled = false;
    commentNode.value = "";
    commentNode.removeAttribute("placeholder");

    if (isNpsSurvey()) {
      var npsLabels = getNpsLabels();
      dom.overlay.querySelector(".rf-feedback-sheet__title").textContent = "";
      questionNode.textContent = questionText || "";
      dom.overlay.querySelector(".rf-feedback-step2__label").textContent = npsLabels.followupHeading;
      commentNode.setAttribute("placeholder", npsLabels.followupPlaceholder);
      dom.overlay.querySelector(".rf-feedback-step2__submit").textContent = npsLabels.submit;
      dom.overlay.querySelector(".rf-feedback-sheet__dismiss").textContent = npsLabels.noThanks;
      dom.overlay.querySelector(".rf-feedback-sheet__close").setAttribute("aria-label", npsLabels.close);
      dom.overlay.querySelector(".rf-feedback-nps-scale-labels__left").textContent = npsLabels.scaleLeft;
      dom.overlay.querySelector(".rf-feedback-nps-scale-labels__right").textContent = npsLabels.scaleRight;
      npsLabelsNode.hidden = false;
      renderNpsScale();
    } else {
      var cesLabels = getCesLabels();
      dom.overlay.querySelector(".rf-feedback-sheet__title").textContent = cesLabels.heading;
      questionNode.textContent = questionText || "";
      dom.overlay.querySelector(".rf-feedback-step2__label").textContent = cesLabels.commentLabel;
      dom.overlay.querySelector(".rf-feedback-step2__submit").textContent = cesLabels.submit;
      dom.overlay.querySelector(".rf-feedback-sheet__dismiss").textContent = cesLabels.noThanks;
      dom.overlay.querySelector(".rf-feedback-sheet__close").setAttribute("aria-label", cesLabels.close);
      npsLabelsNode.hidden = true;
      renderCesScale(cesLabels.scale);
    }

    state.selectedScore = null;
    state.isSubmitting = false;
  }

  /**
   * Shows the bottom sheet: ensures DOM exists, resets UI, displays overlay.
   * @param {string} questionText Campaign question from server
   */
  function openSheet(questionText) {
    ensureDom();
    resetUi(questionText);
    dom.overlay.hidden = false;
    document.body.classList.add("rf-feedback-open");
  }

  /**
   * Hides the bottom sheet and clears in-memory survey state (responseseq, score, submitting flag).
   * Does not call the server — use onDismiss for server-side dismiss when a response row exists.
   */
  function closeSheet() {
    if (!dom.overlay) {
      return;
    }
    dom.overlay.hidden = true;
    if (!shareDom.overlay || shareDom.overlay.hidden) {
      document.body.classList.remove("rf-feedback-open");
    }
    state.responseseq = null;
    state.surveyType = SURVEY_CES;
    state.selectedScore = null;
    state.isSubmitting = false;
  }

  /**
   * Shows a short success toast (top-right) after submit. Auto-hides after 4.5 seconds.
   * @param {string} message Translated toast text (positive or negative)
   */
  function showToast(message) {
    ensureDom();
    dom.toast.textContent = message;
    dom.toast.classList.add("is-visible");
    window.setTimeout(function () {
      dom.toast.classList.remove("is-visible");
    }, 4500);
  }

  /**
   * Handles Ajax errors from AP_FEEDBACK_CHECK / SUBMIT / DISMISS.
   * Delegates to f_errorhandling when available, otherwise shows DEFAULTAJAXERRORMSG alert.
   */
  function handleAjaxError(error) {
    if (typeof f_errorhandling === "function" && error && error.responseText) {
      f_errorhandling(error.responseText);
      return;
    }
    if (window.apex && apex.message && apex.message.alert) {
      apex.message.alert(apex.lang.getMessage("DEFAULTAJAXERRORMSG"));
    }
  }

  /**
   * Step 1 → step 2 transition: stores selected score, highlights button,
   * reveals comment + submit, hides "No thanks" footer.
   * @param {number} score
   * @param {HTMLElement} btnNode
   */
  function onScoreSelected(score, btnNode) {
    state.selectedScore = score;

    if (isNpsSurvey()) {
      dom.overlay.querySelectorAll(".rf-feedback-nps-scale__btn").forEach(function (node) {
        node.classList.toggle("is-selected", node === btnNode);
      });
      dom.overlay.querySelector(".rf-feedback-sheet__question").classList.add("is-faded");
    } else {
      dom.overlay.querySelectorAll(".rf-feedback-scale__btn").forEach(function (node) {
        node.classList.toggle("is-selected", node === btnNode);
      });
    }

    dom.overlay.querySelector(".rf-feedback-step2").classList.add("is-visible");
    dom.overlay.querySelector(".rf-feedback-sheet__footer").classList.add("is-hidden");
    dom.overlay.querySelector("#rfFeedbackComment").focus();
  }

  /**
   * Close (X), "No thanks", or backdrop click.
   * If a pending responseseq exists, calls AP_FEEDBACK_DISMISS (pkg_feedback.p_dismissResponse).
   * If no responseseq or already submitting, closes locally only.
   */
  function onDismiss() {
    if (state.isSubmitting) {
      return;
    }
    if (!state.responseseq) {
      closeSheet();
      return;
    }
    state.isSubmitting = true;
    apex.server.process(
      PROCESS_DISMISS,
      { x01: state.responseseq },
      {
        dataType: "json",
        success: function () {
          closeSheet();
        },
        error: function (err) {
          state.isSubmitting = false;
          handleAjaxError(err);
        }
      }
    );
  }

  /**
   * Resolves toast message from score and survey type.
   * @param {number} score
   * @returns {string}
   */
  function resolveToastMessage(score) {
    if (isNpsSurvey()) {
      var npsLabels = getNpsLabels();
      return score >= 7 ? npsLabels.toastPositive : npsLabels.toastNegative;
    }
    var cesLabels = getCesLabels();
    return score >= 4 ? cesLabels.toastPositive : cesLabels.toastNegative;
  }

  /**
   * Submit step 2: sends score + optional comment via AP_FEEDBACK_SUBMIT (pkg_feedback.p_submitResponse).
   * On success closes sheet and shows toast by survey type.
   */
  function onSubmit() {
    if (!state.responseseq || state.selectedScore == null || state.isSubmitting) {
      return;
    }
    state.isSubmitting = true;
    dom.overlay.querySelector(".rf-feedback-step2__submit").disabled = true;

    apex.server.process(
      PROCESS_SUBMIT,
      {
        x01: state.responseseq,
        x02: state.selectedScore,
        p_clob_01: dom.overlay.querySelector("#rfFeedbackComment").value
      },
      {
        dataType: "json",
        success: function () {
          var selectedScore = state.selectedScore;
          var toastMsg = resolveToastMessage(selectedScore);
          closeSheet();
          showToast(toastMsg);
        },
        error: function (err) {
          state.isSubmitting = false;
          dom.overlay.querySelector(".rf-feedback-step2__submit").disabled = false;
          handleAjaxError(err);
        }
      }
    );
  }

  /**
   * Runs eligibility check and opens the bottom sheet when the user qualifies.
   * @param {{ applicationCode?: string, triggerCode?: string }|undefined} config
   *   Explicit campaign keys (preferred). Omit both to use app-id fallback (480/481 only).
   * Session guards (FEEDBACK_SHOWN_THIS_SESSION) are enforced server-side in AP_FEEDBACK_CHECK.
   */
  function checkAndShow(config) {
    if (state.checkInFlight) {
      return;
    }

    var resolved = resolveTriggerConfig(config);
    if (!resolved) {
      return;
    }

    state.checkInFlight = true;

    apex.server.process(
      PROCESS_CHECK,
      {
        x01: resolved.applicationCode,
        x02: resolved.triggerCode
      },
      {
        dataType: "json",
        success: function (pData) {
          state.checkInFlight = false;
          handleCheckResponse(pData);
        },
        error: function (err) {
          state.checkInFlight = false;
          handleAjaxError(err);
        }
      }
    );
  }

  /**
   * After pending CES (confirm sending), try LOGIN NPS when not eligible.
   */
  function checkLoginSurvey() {
    var loginCfg = resolveLoginDefaults();
    if (!loginCfg) {
      return;
    }
    checkAndShow(loginCfg);
  }

  /**
   * Global hook after navigation — call on Page 0 apexreadyend (or login landing page).
   * 1) AP_FEEDBACK_RUN_PENDING (CES confirm-sending pending items)
   * 2) If not eligible, AP_FEEDBACK_CHECK with LOGIN (NPS on login)
   */
  function runPending() {
    if (state.checkInFlight) {
      return;
    }

    state.checkInFlight = true;

    apex.server.process(
      PROCESS_RUN_PENDING,
      {},
      {
        dataType: "json",
        success: function (pData) {
          state.checkInFlight = false;
          if (pData && pData.success === true && pData.eligible === true) {
            handleCheckResponse(pData);
            return;
          }
          checkLoginSurvey();
        },
        error: function (err) {
          state.checkInFlight = false;
          handleAjaxError(err);
        }
      }
    );
  }

  return {
    checkAndShow: checkAndShow,
    runPending: runPending,
    openShare: openShare,
    close: closeSheet,
    closeShare: closeShare,
    SESSION_ITEM: SESSION_ITEM,
    PENDING_APPLICATION_ITEM: PENDING_APPLICATION_ITEM,
    PENDING_TRIGGER_ITEM: PENDING_TRIGGER_ITEM,
    MSG: MSG,
    MSG_NPS: MSG_NPS,
    MSG_SHARE: MSG_SHARE,
    SURVEY_CES: SURVEY_CES,
    SURVEY_NPS: SURVEY_NPS
  };
})();